import { render, staticRenderFns } from "./App.vue?vue&type=template&id=62ad7df7&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=62ad7df7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ad7df7",
  null
  
)

/* custom blocks */
import block0 from "@/lang/common.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fmandrakey%2FProjects%2Ftwi-dyndns%2Fmanager%2Ffrontend%2Fsrc%2FApp.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/lang/app.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fhome%2Fmandrakey%2FProjects%2Ftwi-dyndns%2Fmanager%2Ffrontend%2Fsrc%2FApp.vue"
if (typeof block1 === 'function') block1(component)

export default component.exports